import OrderReportDetail from "./OrderReportDetail";

export {OrderReportDetail}
export default OrderReportDetail
